import { PropsWithChildren } from 'react';
import styles from './configPanel.module.scss';
import classNames from 'classnames';

interface ConfigSectionProps {
    title: string;
    className?: string;
    'data-qa'?: string;
}

export const ConfigSection = ({
    title,
    children,
    className,
    'data-qa': dataQa = 'config-section',
}: PropsWithChildren<ConfigSectionProps>) => {
    return (
        <div className={classNames(styles.panel__section, className)} data-qa={dataQa}>
            <h1 className={styles['panel__section-title']}>{title}</h1>
            <div className={styles['panel__section-body']}>{children}</div>
        </div>
    );
};
